import { render, staticRenderFns } from "./amAllocation.vue?vue&type=template&id=571dd948"
import script from "./amAllocation.vue?vue&type=script&lang=js"
export * from "./amAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports